// en.js
export default {
  home: "Home",
  home_welcome: "Welcome to ClubBabyPro website",
  home_team_description: "We are a team of students in Computer Science, that decided to develop personal projects during our free-time. You will discover all our differents projects here.",

  // Home / hero
  hero_tagline: "INDEPENDENT GAME STUDIO",
  hero_lead: "We build mobile games that are easy to pick up, each with its own world. Discover Stellar Collect, our space idle clicker, the narrative game Laowai Survival and our arcade game Hot Pursuit.",
  hero_cta_discover: "DISCOVER STELLAR COLLECT",
  hero_cta_laowai: "SEE LAOWAI SURVIVAL",
  hero_cta_hot_pursuit: "VIEW HOT PURSUIT",

  // Projects section
  projects_eyebrow: "Our games",
  projects_title: "What we create",
  game_teaser: "Outrun the police, dodge patrol cars and survive as long as you can in a frantic chase. Collect credits and unlock new vehicles.",
  laowai_new_game_label: "NEW GAME",
  laowai_card_text: "Survive everyday life in China in a humorous narrative game filled with choices, unexpected situations and cultural misunderstandings.",
  learn_more: "Learn more",

  // Hot Pursuit page
  game_pitch: "You play a driver hunted by the police through the city streets. The goal is simple: last as long as you can.",
  game_description_title: "Outrun the police",
  game_description: "Drive at full speed, dodge the patrol cars and survive as long as possible in this frantic chase.",
  game_customisation_title: "Collect & unlock",
  game_customisation: "Grab credits while driving through the city and unlock new vehicles from the shop: sports cars, trucks, buses…",
  download_title: "Ready to drive away?",
  download_sub: "Download Hot Pursuit for free on Google Play.",

  // Laowai Survival page
  laowai_subtitle: "A humorous narrative mobile game about the everyday challenges of life in China.",
  laowai_pitch: "Play as a foreigner trying to survive the everyday challenges of life in China. At each event, choose between three reactions and face the consequences.",
  laowai_fact_android: "Available on Android",
  laowai_fact_genre: "Narrative",
  laowai_fact_choices: "A/B/C choices",
  laowai_fact_languages: "EN & FR",
  laowai_fact_localized: "Two languages",
  laowai_fact_events: "illustrated events",
  laowai_choices_eyebrow: "Choices",
  laowai_choices_title: "Three reactions, one consequence",
  laowai_choices_text: "Each situation offers A/B/C choices. Your decisions can change your resources, your progress, and your ability to make it to the next day.",
  laowai_modes_eyebrow: "Modes",
  laowai_modes_title: "Two ways to survive",
  laowai_classic_title: "Classic Run",
  laowai_classic_text: "Survive 15 days of everyday surprises.",
  laowai_endless_title: "Endless Run",
  laowai_endless_text: "Keep going as long as possible and aim for the best score.",
  laowai_content_eyebrow: "Content",
  laowai_content_title: "45 illustrated events and a Word Guide",
  laowai_content_text: "Laowai Survival is available in English and French. The Word Guide helps explain selected words and situations connected to everyday life in China.",
  laowai_services_title: "Game & Services",
  laowai_services_items: [
    "No account required",
    "No in-app purchases",
    "No Club Baby Pro backend",
    "Optional Google Play Games leaderboard for Endless Run",
    "Optional rewarded ad revive in Endless Run only"
  ],
  laowai_services_note: "The game remains fully playable without signing in to Google Play Games or watching an ad.",
  laowai_internal_testing: "Available on Android.",
  laowai_privacy_link: "Privacy Policy",
  laowai_hero_alt: "Main Laowai Survival artwork showing a foreigner in China",
  laowai_icon_alt: "Laowai Survival icon",
  laowai_choice_alt: "A/B/C choice screen in Laowai Survival",
  laowai_menu_alt: "Laowai Survival main menu",
  laowai_result_alt: "Consequence screen after an event in Laowai Survival",

  // ---------- Stellar Collect ----------
  sc_new_game_label: "NEW GAME",
  sc_card_text: "Tap asteroids to mine them, fly your ship through the belt and turn every tap into a mining empire. A low-poly 3D space idle clicker, free on Android.",
  sc_subtitle: "A low-poly 3D space idle clicker. Tap, mine, upgrade — even while you are away.",
  sc_pitch: "You fly a mining ship through an asteroid corridor with one finger. At first, tapping rocks is the only way forward: the auto turret is an upgrade you have to earn. Every ore you collect pays for drones, stronger hulls and ranks that make the field tougher — and richer.",
  sc_fact_android: "Free on Android",
  sc_fact_genre: "Idle / Clicker",
  sc_fact_genre_sub: "One hand, portrait",
  sc_fact_languages: "EN · FR · ES",
  sc_fact_localized: "Fully translated",
  sc_fact_ranks: "24",
  sc_fact_ranks_sub: "ranks to climb",

  sc_tap_eyebrow: "The gesture",
  sc_tap_title: "A clicker before it is an idle",
  sc_tap_text: "Until you buy the auto turret, every asteroid you break is one you tapped. That is what gives the first big upgrade its weight: automation only means something to a player who has played without it.",
  sc_pilot_eyebrow: "Flying",
  sc_pilot_title: "Drag to go and get the ore",
  sc_pilot_text: "Fragments do not come to you: your magnet radius is deliberately smaller than the corridor is wide. Drag anywhere to bring the ship onto the harvest, weave through the rocks, and let your escort drones lay down fire while you do.",
  sc_progress_eyebrow: "Progression",
  sc_progress_title: "Five upgrades, eight hulls, twenty-four ranks",
  sc_progress_text: "Fire power, turret, magnet, drones and multiplier: every level shows on screen. Dark matter, far rarer, unlocks the garage — from the Scout MK-I to the Abyssal Driller — while ranks harden the rocks and raise your income.",
  sc_idle_eyebrow: "Offline",
  sc_idle_title: "Your drones work without you",
  sc_idle_text: "Close the game and the drones keep collecting, for up to eight hours. The haul is waiting when you come back, along with a daily reward and temporary boosts to fire up whenever you want to push a session.",

  sc_services_title: "Game and services",
  sc_services_items: [
    "No account required",
    "No in-app purchases",
    "No Club Baby Pro server: your run is saved on the device",
    "Playable offline",
    "English, French and Spanish",
    "Optional rewarded ads"
  ],
  sc_services_note: "The game is fully playable without ever watching an ad.",
  sc_download_title: "Ready to mine?",
  sc_download_sub: "Stellar Collect is free on Google Play.",
  sc_privacy_link: "Privacy Policy",
  sc_hero_alt: "Mining ship and escort drones in an asteroid field",
  sc_icon_alt: "Stellar Collect game icon",
  sc_shot_game_alt: "The ship and its drones mining an asteroid in Stellar Collect",
  sc_shot_upgrades_alt: "Stellar Collect upgrades screen",
  sc_shot_garage_alt: "Garage and available hulls in Stellar Collect",
  sc_shot_ranks_alt: "The twenty-four rank path in Stellar Collect",
}
